import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';


interface PaymentOption {
  name: string;
  image: string;
  price: number;
  prefix?: string;
  total?: number;
}

@Component({
  selector: 'app-bank-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bank-grid.component.html',
  styleUrl: './bank-grid.component.scss'
})
export class BankGridComponent implements OnChanges {


  @Input()
  price = 0;

  @Input()
  kokoInstallmentPrice = 0;

  paymentOptions: PaymentOption[] = [];

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['price'] || changes['kokoInstallmentPrice']) {
      this.paymentOptions = [
        { name: 'Bank Transfer', image: 'assets/payment-grid/bank-transfer.png', price: this.price },
        { name: 'Cash', image: 'assets/payment-grid/cash.png', price: this.price },
        { name: 'Visa', image: 'assets/payment-grid/visa.png', price: this.price + this.price * 0.035 }
      ];

      if (this.kokoInstallmentPrice > 0) {
        this.paymentOptions.push({
          name: 'Koko',
          image: 'https://paykoko.com/img/logo1.7ff549c0.png',
          price: this.kokoInstallmentPrice,
          prefix: '3 X ',
          total: this.kokoInstallmentPrice * 3
        });
      }
    }
  }
}
